import Env from '../base/env'
import gsap from 'gsap'
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { part2Play,part2Leave } from '../fx/Common'


export default class revealPart2
{
  constructor(view)
  {
    this.DOM = {
      title: view.querySelector('.title')
    }
    this.FX = {
      title:new SplitText(this.DOM.title, { type:"chars" })
    }
    gsap.set(this.FX.title.chars, { autoAlpha: 0 })
    this.tl = gsap.timeline()

    this.fxScrollExit()
  }

  destroy()
  {
    gsap.set(this.FX.title.chars, { autoAlpha:0 })
  }

  play()
  {
    part2Play(this.tl,this.FX.title.chars)
  }

  leave(cbStart=null,cbComplete=null)
  {
    part2Leave(this.tl,this.FX.title.chars,cbStart,cbComplete)
  }

  fxScrollExit()
  {

    this.tlBottom = gsap.timeline({
      scrollTrigger:{
        trigger:document.querySelector('.jsStep10'),
        start:'top -20%',
        end:'bottom -20%',
        scrub:1,
      }
    })
    this.tlBottom.add([
      gsap.fromTo(
        this.FX.title.elements[0],
        {
          y:0
        },
        {
          y:100
        }
      ),
      gsap.fromTo(
        document.querySelector('.jsCanvasB'),
        {
          rotate:0,
          scale:1
        },
        {
          rotate:10,
          scale:1.2
        }
      )
    ])



  }
}
